<template>
  <div id="login" class="zindex10">

    <!-- <img class="bgmarmoleado" src="../assets/imgs/raspaygana/marmoleado-azul.png" alt="Bg"> -->

    <section class="bannerprincipal pb-5">
      
      <div class="container">
        <div class="row">
          

          <div class="col-8 offset-2 col-md-6 offset-md-3 offset-md-0 h-100">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class="mt-3 zindex10"
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    class="img-fluid"
                    src="../assets/imgs/raspaygana/raspa-y-gana.png"
                    alt="Raspa y Gana"
                  />
                </div>

                
                
              </div>
            </div>
          </div>


          <div class="col-12 col-md-12 offset-md-0 h-100 zindex10 marginencimado">
            <div class="">
              <div class="d-flex justify-content-center align-items-center">
                <div
                  class=""
                  data-aos="fade-up"
                  data-aos-delay="200"
                >
                  <img
                    class="img-fluid "
                    src="../assets/imgs/raspaygana/premios.png"
                    alt="Raspa y Gana"
                  />
                </div>

                
                
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <section>
      <div class="container marginencimado">
        <div class="row pt-5 mb-4">
          <div
            class="col-12 offset-lg-0 pb-4 zindex10"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <div
              class="row fG justify-content-center align-items-center pb-4"
            >
              <div class="col-2 text-center">
                <div class="bold rojo fXXG">
                <img class="img-fluid" src="../assets/imgs/raspaygana/paso-1.png" alt="paso 1">
              </div>
              </div>

              <div class="col-10">
                <div class="">
                  <span class="blanco">Compra 1 saco de </span> <span class="bold amarillo">Cemento Chihuahua</span>
                </div>
              </div>
            </div>

            <div
              class="row fG justify-content-center align-items-center pb-4"
            >
              <div class="col-2 text-center">
                <div class="bold rojo fXXG">
                <img class="img-fluid" src="../assets/imgs/raspaygana/paso-2.png" alt="paso 2">
              </div>
              </div>

              <div class="col-10">
                <div class="">
                  <span class="bold amarillo">Registra tu compra</span> <span class="blanco">y recibe un raspadito digital </span> 
                </div>
              </div>
            </div>


            <div
              class="row fG justify-content-center align-items-center pb-4"
            >
              <div class="col-2 text-center">
                <div class="bold rojo fXXG">
                <img class="img-fluid" src="../assets/imgs/raspaygana/paso-3.png" alt="paso 3">
              </div>
              </div>

              <div class="col-10">
                <div class="">
                  <span class="blanco">Además </span> <span class="bold amarillo">responde correctamente</span> <span class="blanco">nuestra trivia y</span> <span class="blanco bold">
                    ¡Descubre al instante tu premio!
                  </span>
                </div>
              </div>
            </div>
          </div>

          
          
        </div>

        <!-- <div class="py-5 row">
          <div class="col-12">
            <div class="rojo text-center px-4 fG bold">
              banner
              </div>
          </div>
        </div> -->
      
        <div class="row pb-5 bgazuloscuro borderrounded mb-5">
          <div class="col-12 zindex10">
            <div class="row">
              <div class="col-12 " v-if="showLoginForm">
                <form @submit="login($event)" class="py-5 r15">
                  <div class="col-12 text-center pb-4">
                    <div class="fXG blanco">
                      Para comenzar <span class="bold">inicia sesión</span>:
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="d-flex flex-column pb-4">
                      <div class="w-100 px-2">
                        <input
                          v-model.trim="loginForm.email"
                          type="email"
                          placeholder="E-mail"
                          id="email1"
                          class="text-left"
                          required
                        />
                      </div>
                      <div class="w-100 px-2">
                        <input
                          v-model.trim="loginForm.password"
                          type="password"
                          placeholder="Contraseña"
                          id="password1"
                          class="text-left"
                          required
                        />
                      </div>
                      <div class="px-2 text-center d-flex align-items-center">
                        <button
                          type="submit"
                          class="blanco pointer d-flex align-items-center justify-content-center bold btnaction fG ml-auto mr-auto w-100"
                        >
                          CONTINUAR
                        </button>
                      </div>
                    </div>
                    <div class="extras text-right">
                      <a @click="togglePasswordReset()" class="pointer blanco bold underlined"
                        >Olvidé mi contraseña</a
                      >
                    </div>
                  </div>
                </form>

                <!-- <div class="extras2 text-center pt-3 pb-3 fG gris bold">
                 ¿Aún no tienes cuenta?
                </div> -->

                <div class="w-100 text-center fG bold blanco">
                  Si aún no tienes cuenta,
                  <a @click="toggleForm()" class="w-100 d-block blanco fG bold pointer underline"
                    >CREA UNA AQUÍ</a
                  >
                 
                </div>

              </div>

              <div v-else class="col-12">
                <form @submit="signup($event)" class=" py-5 r15">
                  <div class="col-12 text-center pb-4 blanco zindex10">
                    <h2>
                      <span class="bold">Regístrate</span> para participar
                    </h2>
                  </div>
                  <div class="col-12 zindex10">
                    <div class="row pb-4">
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">Nombre</div>
                        <input
                          v-model.trim="signupForm.nombre"
                          type="text"
                          placeholder="Nombre"
                          id="nombre"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">Apellido</div>
                        <input
                          v-model.trim="signupForm.apellido"
                          type="text"
                          placeholder="Apellido"
                          id="apellido"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">E-mail</div>
                        <input
                          v-model.trim="signupForm.email"
                          type="email"
                          placeholder="E-mail"
                          id="email2"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">Celular</div>
                        <input
                          v-model.trim="signupForm.celular"
                          type="text"
                          placeholder="Celular (10 dígitos)"
                          id="celular"
                          maxlength="10"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">Contraseña</div>
                        <input
                          v-model.trim="signupForm.password"
                          type="password"
                          placeholder="Contraseña"
                          id="password2"
                          required
                        />
                      </div>
                      <!-- <div class="col-lg-6 pb-3">
                        <div class="fG blanco">Género</div>
                        <select v-model="signupForm.genero" required>
                          <option value="" hidden>Selecciona una opción</option>
                          <option value="Femenino">Femenino</option>
                          <option value="Masculino">Masculino</option>
                        </select>
                      </div> -->
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">
                          Fecha de nacimiento (DD/MM/AAAA)
                        </div>
                        <input
                          v-model.trim="signupForm.fecha_nacimiento"
                          :type="dateType"
                          placeholder="Fecha de nacimiento"
                          id="fecha_nacimiento"
                          @click="cambiaFechaType()"
                          @focus="cambiaFechaType()"
                          required
                        />
                      </div>
                      <div class="col-lg-6 pb-3">
                        <div class="fG blanco">
                          ¿Cómo prefieres ser contactado?
                        </div>
                        <select v-model="signupForm.medio_de_contacto" required>
                          <option value="" hidden>Selecciona una opción</option>
                          <option value="Correo electrónico">Correo electrónico</option>
                          <option value="Teléfono">Teléfono</option>
                        </select>
                      </div>
                      <div class="col-12 pb-3 text-center blanco">
                        <label>
                          <input type="checkbox" v-model="signupForm.terminos" required> Acepto los términos y condiciones del <a href="./Terminos y Condiciones CCH.pdf#page=13" class=" blanco underlined" target="_blank" rel="noopener noreferrer">Aviso de Privacidad</a>.
                        </label>
                      </div>
                    </div>
                    <div class="row pb-5">
                      <div class="col-12 text-center">
                        <button
                          type="submit"
                          class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
                        >
                          Crear cuenta
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="extras text-center">
                    <a @click="toggleForm()" class="pointer blanco underlined"
                      >Regresar al Log In</a
                    >
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
     
        <!-- <div class="row py-5">
          <div class="col-12 text-center azul fXXG">GANADORES</div>
          <div class="col-12 text-center  azul fG py-2">Consulta la lista de ganadores semanales aquí:</div>
          <div class="col-12 text-center pb-5">
            <router-link
              to="/ganadores"
              class="amarillo pointer d-flex align-items-center justify-content-center btnaction fG ml-auto mr-auto w-100"
            >
              Lista de ganadores semanales
            </router-link>
          </div>
        </div> -->

      </div>
    </section>

    <PasswordReset
      v-if="showPasswordReset"
      @close="togglePasswordReset()"
    ></PasswordReset>

    <Footer></Footer>
  </div>
</template>

<script>

import PasswordReset from "@/components/PasswordReset";
import MonederoSet from "@/components/MonederoSet";

import Footer from "@/components/Footer";
import AOS from "aos";
import swal from "sweetalert2";

// import Parallax from "parallax-js";

import { mapState } from "vuex";

export default {
  components: {
    PasswordReset,
    Footer,

  },
  data() {
    return {
      loginForm: {
        email: "",
        password: "",
      },
      signupForm: {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        genero:"",
        terminos: "",
        medio_de_contacto: ""
      },
      showLoginForm: true,
      showPasswordReset: false,
      showMonedero: false,
      dateType: "text",
      explotar: true,
    };
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation,
      disable: "mobile"
    });

    var scene = document.getElementById("scene");

    var vm = this;
    setTimeout(function () {
      vm.explotar = false;
      //var parallaxInstance = new Parallax(scene);
    }, 1000);
  },
  computed: {
    ...mapState(["userProfile"]),
    showNav() {
      return Object.keys(this.userProfile).length > 1;
    },
  },
  methods: {
    cambiaFechaType() {
      this.dateType = "date";
      if (this.signupForm.fecha_nacimiento == "")
        this.signupForm.fecha_nacimiento = "1980-01-01";
    },
    toggleForm() {
      this.showLoginForm = !this.showLoginForm;
    },
    togglePasswordReset() {
      this.showPasswordReset = !this.showPasswordReset;
    },
    login(e) {
      e.preventDefault();

      this.$store.dispatch("login", {
                email: this.loginForm.email,
                password: this.loginForm.password,
              });

      // // // const https = require("https");
      // // // var qData = {
      // // //   email: this.loginForm.email,
      // // // };
      // // // this.$http
      // // //   .post(
      // // //     process.env.VUE_APP_API_URL + "login.php",
      // // //     JSON.stringify(qData),
      // // //     {
      // // //       emulateJSON: true,
      // // //       httpsAgent: new https.Agent({ rejectUnauthorized: false }),
      // // //       headers: {
      // // //         "Content-Type": "text/plain",
      // // //         //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
      // // //       },
      // // //     }
      // // //   )
      // // //   .then(
      // // //     (response) => {
      // // //       // get body data
      // // //       console.log("envio mail");
      // // //       console.log(response);

      // // //       let res = response.body;

      // // //       if (res.status == "ok") {
      // // //         this.$store.dispatch("login", {
      // // //           email: this.loginForm.email,
      // // //           password: this.loginForm.password,
      // // //         });
      // // //       } else {
      // // //         swal.fire("Oops", res.msg, "warning");
      // // //       }
      // // //     },
      // // //     (error) => {
      // // //       // error callback
      // // //       console.log("error callback");
      // // //       console.log(error);
      // // //     }
      // // //   );
    },
    signup(e) {
      e.preventDefault();

      if (this.validPass(this.signupForm.password) === false) {
        swal.fire(
          "Oops",
          "La contraseña debe tener al menos 8 dígitos",
          "warning"
        );
        return false;
      }

      if (this.validPhone(this.signupForm.celular) === false) {
        swal.fire(
          "Oops",
          "El celular debe ser un número válido de 10 dígitos.",
          "warning"
        );
        return false;
      }

      this.registro();
    },
    async registro(monedero = "") {

      this.$store.dispatch('showLoader', true)


      
      console.log({ registro: this.signupForm });

      // // // await this.enviaCorreo(
      // // //   this.signupForm.nombre,
      // // //   this.signupForm.apellido,
      // // //   this.signupForm.email
      // // // );

      await this.$store.dispatch("signup", this.signupForm);
    },
    async enviaCorreo(nombre, apellido, email) {
      //LLAMAR ENVIO DE CORREO
      let thes = this;
      const https = require("https");
      var qData = {
        nombre: nombre,
        apellido: apellido,
        email: email,
      };
      this.$http
        .post(
          process.env.VUE_APP_API_URL + "registro-prueba.php",
          JSON.stringify(qData),
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "text/plain",
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            },
          }
        )
        .then(
          async (response) => {
            // get body data
            console.log("envio mail");
            console.log(response);

            let res = response.body;
            if (res.status === "ok") {
              await this.$store.dispatch("signup", thes.signupForm);

              thes.$gtag.event("conversion", {
                send_to: "AW-978746627/-5dyCPTN_-IBEIP62dID",
              });

              //window.fbq("track", "CompleteRegistration");

              
              this.resetForm();
              this.toggleForm();
            } else {
              swal.fire("Oops", res.msg, "warning");
              this.resetForm();
              this.toggleForm();
            }
          },
          (error) => {
            // error callback
            console.log("error callback");
            console.log(error);
          }
        );
    },
    resetForm() {
      this.signupForm = {
        nombre: "",
        apellido: "",
        email: "",
        celular: "",
        password: "",
        fecha_nacimiento: "",
        monedero: "",
        terminos: false
      };
    },
    validPass(password) {
      if (password.length < 8) {
        return false;
      }
      return true;
    },
    validPhone(celular) {
      if (celular.length < 10) {
        return false;
      }
      if (isNaN(celular)) {
        return false;
      }

      return true;
    },
  },
};
</script>
